<template>
  <div>
    <div class="index-body">
      <div class="logo">
        <a href="https://www.godjiyi.cn/" target="_blank" style="text-decoration: none; color: rgb(7, 185, 148)"><i class="el-icon-s-home"></i>戈吉</a>
        <span style="float: right;">
          <el-button size="mini" icon="el-icon-refresh" circle @click="reLoad"></el-button>
        </span>
      </div>
      <div class="index-title">
        {{headMsg}}
      </div>
      <div class="index-subtitle" v-if="!isOthers">
        <el-link :href="mainHome" style="font-size: 20px" target="_blank" type="danger">Protocol loading comparison</el-link>
      </div>
      <el-row type="flex" justify="center" class="link-round-row">
        <el-col :span="2" style="text-align: center">
          <el-link :href="http1.home" :underline="false" class="link-round" target="_blank" type="info">HTTP1.1</el-link>
        </el-col>
        <el-col :span="2" style="text-align: center">
          <el-link :href="http2.home" :underline="false" class="link-round" target="_blank" type="info">HTTP2</el-link>
        </el-col>
        <el-col :span="2" style="text-align: center">
          <el-tooltip content="You should using Chrome browser" placement="top">
            <el-link :href="http3.home" :underline="false" class="link-round" target="_blank" type="info">QUIC</el-link>
          </el-tooltip>
        </el-col>
        <el-col :span="2" style="text-align: center">
          <el-tooltip content="You should using Firefox browser" placement="top">
            <el-link :href="http3.home" :underline="false" class="link-round" target="_blank" type="info">HTTP3</el-link>
          </el-tooltip>
        </el-col>
      </el-row>
      <div class="index-demo">
        <el-row v-if="isHttp1" :gutter="2" type="flex" justify="center">
          <el-col :span="6">
            <SplitImg ref="http1" :baseUrl="http1.url" :showMsg="http1.showMsg"></SplitImg>
          </el-col>
        </el-row>
        <el-row v-else-if="isHttp2" :gutter="2" type="flex" justify="center">
          <el-col :span="6">
            <SplitImg ref="http2" :baseUrl="http2.url" :showMsg="http2.showMsg"></SplitImg>
          </el-col>
        </el-row>
        <el-row v-else-if="isHttp3" :gutter="2" type="flex" justify="center">
          <el-col :span="6">
            <SplitImg ref="http3" :baseUrl="http3.url" :showMsg="http3.showMsg"></SplitImg>
          </el-col>
        </el-row>
        <el-row v-else :gutter="2" type="flex" justify="center">
          <el-col :span="6">
            <SplitImg ref="http1" :baseUrl="http1.url" :showMsg="http1.showMsg"></SplitImg>
          </el-col>
          <el-col :span="6">
            <SplitImg ref="http2" :baseUrl="http2.url" :showMsg="http2.showMsg"></SplitImg>
          </el-col>
          <el-col :span="6">
            <SplitImg ref="http3" :baseUrl="http3.url" :showMsg="http3.showMsg"></SplitImg>
          </el-col>
        </el-row>
      </div>
      <div style="text-align: center; margin-top: 20px">
        <el-button @click="githubStarClick" size="mini">
          <svg class="svg-icon" aria-hidden="true">
            <use xlink:href="#icongithub"></use>
          </svg>
          <span style="font-weight: bold">Star</span>
        </el-button>
        <div style="margin-top: 10px">
          <el-link target="_blank" type="danger" style="color: red" href="https://github.com/jiyiren/quic-web">How to build web/api supporting quic or http3 ?</el-link>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/components/footer/index'
import SplitImg from '@/components/splitimg/index'
import CommonUtil from '../common/CommonUtil'
import aliSvgIcon from '@/components/ali-svg-icon/index'

export default {
  name: 'Index',
  components: {
    Footer,
    SplitImg,
    aliSvgIcon
  },
  computed: {
    isHttp1 () {
      if (this.getHostName().indexOf('http1') !== -1) {
        return true
      }
      return false
    },
    isHttp2 () {
      if (this.getHostName().indexOf('http2') !== -1) {
        return true
      }
      return false
    },
    isHttp3 () {
      if (this.getHostName().indexOf('http3') !== -1 || this.getHostName().indexOf('quic') !== -1) {
        return true
      }
      return false
    },
    isOthers () {
      if (this.isHttp1 || this.isHttp2 || this.isHttp3) {
        return false
      }
      return true
    },
    iconClassVal () {
      return 'ali-icon-github'
    }
  },
  data () {
    return {
      headMsg: 'HTTP3 or QUIC is the future of the Web, and it is here!',
      mainHome: 'https://demo.godjiyi.cn',
      http1: {
        home: 'https://http1.godjiyi.cn:9443',
        url: 'https://http1.godjiyi.cn:9443/static/lsimg/lsimg_',
        showMsg: {
          title: 'HTTP/1.1'
        }
      },
      http2: {
        home: 'https://http2.godjiyi.cn:9444',
        url: 'https://http2.godjiyi.cn:9444/static/lsimg/lsimg_',
        showMsg: {
          title: 'HTTP/2'
        }
      },
      http3: {
        home: 'https://http3.godjiyi.cn:9445',
        url: 'https://http3.godjiyi.cn:9445/static/lsimg/lsimg_',
        showMsg: {
          title: 'HTTP/3(QUIC)'
        }
      }
    }
  },
  methods: {
    reLoad () {
      if (this.$refs.http1 !== undefined) {
        this.$refs.http1.reload()
      }
      if (this.$refs.http2 !== undefined) {
        this.$refs.http2.reload()
      }
      if (this.$refs.http3 !== undefined) {
        this.$refs.http3.reload()
      }
    },
    getHostName () {
      return CommonUtil.getCurrentHostname()
    },
    githubStarClick () {
      CommonUtil.openUrl("https://github.com/jiyiren/quic-web")
    }
  }
}
</script>

<style scoped>
  .index-body {
    padding-top: 40px;
  }
  .index-body .logo {
    max-width: 1080px;
    margin: auto;
  }
  .index-title {
    color: black;
    text-align: center;
    font-size: 24px;
    line-height: 136%;
    font-weight: 700;
    clear: both;
  }
  .index-subtitle {
    text-align: center;
    margin-top: 10px;
  }
  .index-demo {
    min-height: 500px;
  }
  .link-round-row {
    margin-top: 10px;
  }
  .link-round-row a:hover {
    color: #ec420b;
  }
  .link-round {
    background-color: #07b994;
    border-radius: 30px;
    padding: 5px 10px 5px 10px;
    color: white;
  }
  .svg-icon {
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue